import { render, staticRenderFns } from "./VHero.vue?vue&type=template&id=8b00a15a&scoped=true"
import script from "./VHero.vue?vue&type=script&lang=ts"
export * from "./VHero.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b00a15a",
  null
  
)

export default component.exports